<template>
    <div class="flex items-center rounded-xl">
        <span class="fa-stack">
            <i class="fas fa-circle fa-stack-2x" :class="value ? 'text-green-100' : 'text-red-100'"></i>
            <i class="fas fa-stack-1x" :class="value ? 'fa-check text-green-600' : 'fa-times text-red-500'"></i>
        </span>
        <div class="leading-tight font-medium ml-1.5">
            <div :class="value ? 'text-green-600' : 'text-red-600'">{{ value ? yes : no }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Boolean,
        yes: {
            type: String,
            default: 'Yes',
        },
        no: {
            type: String,
            default: 'No',
        },
    },
}
</script>
